import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bookmark, BookOpen, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { BookCard, EmptyState } from "@/components/cards";

const TABS = [["saved", "Saved", Bookmark], ["reading", "Continue Reading", BookOpen], ["completed", "Completed", CheckCircle2]];

export default function Library() {
  const { user } = useApp();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("saved");
  useEffect(() => {
    if (user === null) { nav("/login"); return; }
    if (user) api.get("/me/library").then((r) => setD(r.data));
  }, [user]); // eslint-disable-line

  if (!user || !d) return <div className="py-24 text-center text-muted-foreground">Loading…</div>;
  const list = d[tab] || [];

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10 fade-in">
      <h1 className="text-4xl md:text-5xl font-display font-bold">My Library</h1>
      <div className="flex gap-2 mt-6 flex-wrap">
        {TABS.map(([id, label, Icon]) => (
          <button key={id} onClick={() => setTab(id)} data-testid={`library-tab-${id}`}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${tab === id ? "bg-primary text-primary-foreground" : "border border-border hover:border-primary"}`}>
            <Icon className="h-4 w-4" /> {label} ({d[id]?.length || 0})
          </button>
        ))}
      </div>
      <div className="mt-8">
        {list.length ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {list.map((b) => <BookCard key={b.id} book={b} />)}
          </div>
        ) : <EmptyState icon={Bookmark} title={`Nothing in ${TABS.find((t) => t[0] === tab)[1]} yet`} subtitle="Save stories and pick up where you left off — it all lives here." />}
      </div>
    </div>
  );
}
